import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import CategoryDropdown from '@/pages/home/components/CategoryDropdown';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import WhatIs from '@/pages/home/components/WhatIs';
import Benefits from '@/pages/home/components/Benefits';
import ExploreCategories from '@/pages/home/components/ExploreCategories';
import HowItWorks from '@/pages/home/components/HowItWorks';
import ArticleLinks from '@/pages/home/components/ArticleLinks';
import FAQ from '@/pages/home/components/FAQ';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryDropdown />
        <CategoryGrid />
        <WhatIs />
        <Benefits />
        <ExploreCategories />
        <HowItWorks />
        <ArticleLinks />
        <FAQ />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Kakobuy Finds',
            url: 'https://kakobuyfinds.site/',
            description: 'Discover the best Kakobuy Spreadsheet with trending products, verified finds, detailed comparisons, and expert shopping guides.',
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: 'https://kakobuyfinds.site/search?q={search_term_string}',
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </>
  );
}